import Model from './model.js';
import Log from 'lib/log';
const log = Log('models/vehicle');

export default class Vehicle extends Model {
    defaults() {
        return {
            type: '',
            year: (new Date()).getFullYear(),
            model: ''
        };
    }

    constraints() {
        return {
            type: {presence: true},
            year: {
                presence: true,
                numericality: {
                    onlyIntegers: true,
                    lessThanOrEqualTo: (new Date()).getFullYear()
                }
            },
            model: {presence: true}
        };
    }

    save() {
        log.warn('Vehicle Model is not meant to be persisted.');
        return Promise.resolve(this);
    }
}



// WEBPACK FOOTER //
// ./app/new-models/vehicle.js